import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { saveChildbirthOB } from '../../procedures/childbirthOB/store/childbirthOB.actions'
import { QuickActionsConstants } from '../store/quickActions.constants'

export function* setChildbirthQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addChildbirthOBToTimeline } = quickActionsObject
  if (addChildbirthOBToTimeline) {
    yield put(saveChildbirthOB())
  }
}

export function* setChildbirthQuickActionTimeLineRowSaga() {
  yield takeLatest([QuickActionsConstants.SET_ADD_CHILDBIRTHOB_TO_TIMELINE], setChildbirthQuickActionTimeLineRow)
}
